import { insertAndFocus } from 'common/Prose/utils/insertAndFocus'
import { pick } from 'lodash'
import { nodes, schema } from 'prose-core'
import { ExtractStrongNodeSpecAttributes } from 'prose-core'
import { type EditorView } from 'prosemirror-view'
import { findClosestCodeBlock } from 'proseShared/utils/findClosestCodeBlock'

export const useCodeBlockButton = (view: EditorView) => {
  return () => {
    const {
      selection: {
        $from: { pos },
      },
      tr: { doc },
    } = view.state
    let codeBlockAttrs: Partial<ExtractStrongNodeSpecAttributes<typeof nodes.code_block>> = { lineNumbers: false }
    const closestCodeBlockInfo = findClosestCodeBlock(doc, pos)
    if (closestCodeBlockInfo !== null) {
      const [, codeBlockNode] = closestCodeBlockInfo
      Object.assign(codeBlockAttrs, pick(codeBlockNode.attrs, ['mime', 'theme', 'lineNumbers']))
    }
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    insertAndFocus(view, schema.nodes.code_block.createAndFill(codeBlockAttrs)!)
  }
}
